// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1mAZt","rowsWrapper":"style_rowsWrapper__J_ABn","rowWrapper":"style_rowWrapper__1UYlv"};